var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "rebirth-enabled",
      "title": _vm.$t('rebirthNew'),
      "size": "md",
      "hide-footer": true
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "rebirth_orb"
  }), _c('p', [_c('span', [_vm._v(_vm._s(_vm.$t('rebirthUnlock')))])])])]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "col-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function ($event) {
        return _vm.close();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('close')) + " ")])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }